import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Redirect, Link } from 'react-router-dom';
import slugify from 'slugify';

import { pokemon } from 'data/pokemon';
import formatNum from 'utils/formatNum';

import Wrap from 'components/Wrap';
import PokemonMoveCard from 'components/PokemonMoveCard';
import TypeBadge from 'components/TypeBadge';
import TypeTable from 'components/TypeTable';

class PokemonSingle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pokemon: props.match.params.query.toLowerCase()
    }
  }

  componentWillReceiveProps() {
    this.setState({
      pokemon: this.props.match.params.query.toLowerCase()
    });
  }

  componentDidMount() {
    window.PkSpr.process_dom();
  }

  componentDidUpdate() {
    document.querySelectorAll('.pkspr').forEach((el) => {
      el.removeChild(el.querySelector('i'));
    });
    
    window.PkSpr.process_dom();
  }

  render() {
    const totalPokemon = pokemon.length;

    const thisPokemon = pokemon.find((pokemon) => {
      return pokemon.name.toLowerCase() === this.props.match.params.query.toLowerCase();
    });

    if(!thisPokemon) {
      return (
        <Redirect to="/" />
      )
    } else {
      const prevPokemon = pokemon.find((pokemon) => {
        return pokemon.number === thisPokemon.number - 1;
      }) || pokemon.find((pokemon) => {
        return pokemon.number === totalPokemon;
      });

      const nextPokemon = pokemon.find((pokemon) => {
        return pokemon.number === thisPokemon.number + 1;
      }) || pokemon.find((pokemon) => {
        return pokemon.number === 1;
      });

      return (
        <div id="PokemonSingle" className="PokemonSingle">
          <Helmet>
            <link rel="canonical" href={"http://pokego.fyi/pokemon/"+thisPokemon.name.toLowerCase()} />
            <title>{thisPokemon.name} Moveset & Stats · Pokemon Go Database · pokego.fyi</title>
            <meta name="description" content={thisPokemon.name + ' (' + '#'+formatNum(thisPokemon.number,3) + ') is a '+thisPokemon.type.join(' / ')+' type Pokemon with '+thisPokemon.attack+' attack, '+thisPokemon.defense+' defense, '+thisPokemon.stamina+' stamina and '+thisPokemon.cp+' max CP in Pokemon Go.'} />
          </Helmet>

          <Wrap>
            <div className="wrap:m nm-y:s nm-x:s s(m-x:a) bgc:white p:s">
              <nav className="d:f fld:r jc:sb ai:c  p-b:xs p-x:xs nm-x:s nm-t:xs m-y:s  bd-b:m bdc:light-pewter  ts:tiny lc:pewter">
                <div>
                  <Link className="d:b p:xs c:pewter fw:6  hv(o:75)" to="/pokemon/">← All Pokemon</Link>
                </div>
                <div className="d:f fld:r  ls:s">
                  <Link className="d:b p:xs bd-r:m bdc:light-pewter c:pewter  hv(o:75)" to={'/pokemon/'+prevPokemon.name.toLowerCase()}>
                    <span><span className="c:pewter">←</span> #{formatNum(prevPokemon.number, 3)}</span> <span id={'pkmn-' + formatNum(prevPokemon.number, 3)} className={'nm-t:xs nm-b:xs m(nm-t:xs) m(nm-b:xs) pkspr pkmn-' + formatNum(prevPokemon.number, 3)}></span>
                  </Link>
                  <Link className="d:b p:xs c:pewter  hv(o:75)" to={'/pokemon/'+nextPokemon.name.toLowerCase()}>
                    <span id={'pkmn-' + formatNum(nextPokemon.number, 3)} className={'nm-t:xs nm-b:xs m(nm-t:xs) m(nm-b:xs) pkspr pkmn-' + formatNum(nextPokemon.number, 3)}></span> <span>#{formatNum(nextPokemon.number, 3)} <span className="c:pewter">→</span></span>
                  </Link>
                </div>
              </nav>

              <article>
                <div className="g:12 wrap:xs m-x:a">
                  <header className="PokemonSingle__Header  gcol:6  p-x:s p-b:xs">
                    <span className="PokemonSingle__Number  ts:tiny ls:s  c:pewter">#{formatNum(thisPokemon.number, 3)}</span>
                    <h1 className="PokemonSingle__Name  ts:subheading fw:5 c:dark-pewter">{thisPokemon.name}</h1>
                    <div className="PokemonSingle__Type  m-t:xs  g:12">
                      {thisPokemon.type.map((type) => {
                        return (
                          <div className="gcol:6  p-r:xs" style={{maxWidth: '90px'}} key={type}>
                            <TypeBadge type={type} />
                          </div>
                        )
                      })}
                    </div>
                  </header>

                  <figure className="PokemonSingle__Image  gcol:6 nm-t:xs  ta:r">
                    <span id={'pkmn-' + formatNum(thisPokemon.number, 3)} className={'pkspr pkmn-' + formatNum(thisPokemon.number, 3)}></span>
                  </figure>
                </div>

                <section className="PokemonSingle__Stats  wrap:xs m-t:s m-x:a">
                  <div className="d:t tl:f w:100  p-y:xs  bd-t:m bdc:light-pewter  ts:body ta:c c:dark-pewter">
                    <div className="p:xs d:tc">
                      <div className="fw:5">{thisPokemon.attack}</div>
                      <div className="ts:tiny c:pewter">Attack</div>
                    </div>
                    <div className="p:xs d:tc">
                      <div className="fw:5">{thisPokemon.defense}</div>
                      <div className="ts:tiny c:pewter">Defense</div>
                    </div>
                    <div className="p:xs d:tc">
                      <div className="fw:5">{thisPokemon.stamina}</div>
                      <div className="ts:tiny c:pewter">Stamina</div>
                    </div>
                    <div className="p:xs d:tc">
                      <div className="fw:5">{thisPokemon.cp}</div>
                      <div className="ts:tiny c:pewter">Max CP</div>
                    </div>
                 </div>
                </section>

                <section className="PokemonSingle__Moves p-x:s s(p-x:xs)  s(nm-x:s) bd-t:m bdc:light-pewter    g:12">
                  <section className="PokemonSingle__QuickMoves  wrap:xs m-x:a m-t:s s(m-y:s) p-b:s s(p-b:0)  s(bd:0)  m(p:xs) gcol:12 s(gcol:6)">
                    <header className="">
                     <h1 className="ts:tiny ta:c c:dark-pewter">Quick Moves</h1>
                    </header>

                    {thisPokemon.fastMoves.map((move) => {
                      return (
                        <Link className="d:b bd-b:m bdc:light-pewter  hv(o:75)" key={move} to={'/moves/'+slugify(move.toLowerCase())}>
                          <PokemonMoveCard move={move} userTypes={thisPokemon.type} />
                        </Link>
                      );
                    })}
                  </section>

                  <section className="PokemonSingle__ChargeMoves  wrap:xs m-x:a s(m-y:s) m(p:xs) gcol:12 s(gcol:6)">
                    <header className="">
                     <h1 className="ts:tiny ta:c c:dark-pewter">Charge Moves</h1>
                    </header>

                    {thisPokemon.chargeMoves.map((move) => {
                      return (
                        <Link className="d:b bd-b:m bdc:light-pewter  hv(o:75)" key={move} to={'/moves/'+slugify(move.toLowerCase())}>
                          <PokemonMoveCard move={move} userTypes={thisPokemon.type} />
                        </Link>
                      );
                    })}
                  </section>
                </section>

                <section className="PokemonSingle__TypeEffectiveness  m-y:s m-b:l">
                  <header className="">
                    <h1 className="ts:tiny ta:c c:dark-pewter">Type Effectiveness Chart</h1>
                  </header>

                  <div className="m-y:s">
                    <TypeTable type={thisPokemon.type} />
                  </div>
                </section>
              </article>
            </div>
          </Wrap>
        </div>
      );
    }
  }
}

export default PokemonSingle;



// WEBPACK FOOTER //
// ./src/scenes/PokemonSingle.js